import { validationErrors } from "../utils";
import ajaxService from "./ajax-service";

class InventoryReport {
  async fetch(page, data, all = false) {
    const response = all
      ? await ajaxService.post("/reports/inventory?all=true", data)
      : await ajaxService.post(`/reports/inventory?page=${page}`, data);
    if (response?.success ?? false) {
      return response;
    } else {
      const errors = response.data.errors;
      return validationErrors(errors);
    }
  }
  async sendMail(data) {
    const response = await ajaxService.post("/reports/inventory/send-mail", data);
    if (response?.success ?? false) {
      return response;
    } else {
      const errors = response.data.errors;
      return validationErrors(errors);
    }
  }
}

const inventoryReportService = new InventoryReport();
export default inventoryReportService;
